import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  Box,
  VStack,
  HStack,
  Icon,
  Flex,
} from '@chakra-ui/react';
import { FaBell, FaExclamationTriangle } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import {
  getPendingNonTesseraOrders,
  getPendingNotificationsCount,
  getPendingSoci,
} from '../utils/pendingNotifications';

const NotificationPopup = ({ isOpen, onClose, userData }) => {
  const pendingTesseramenti = getPendingSoci(userData);
  const pendingOrders = getPendingNonTesseraOrders(userData);
  const totalNotifications = getPendingNotificationsCount(userData);

  // Gestisce la chiusura del popup salvando la data corrente
  const handleClose = () => {
    const LAST_POPUP_DATE_KEY = 'lastNotificationPopupDate';
    const now = new Date();
    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    ).getTime();
    localStorage.setItem(LAST_POPUP_DATE_KEY, today.toString());
    onClose();
  };

  const rows = [
    {
      key: 'tesseramenti',
      title: 'Tesseramenti in attesa',
      count: pendingTesseramenti.length,
      label: 'tesseramento',
      plural: 'tesseramenti',
    },
    {
      key: 'eventi',
      title: 'Eventi in attesa',
      count: pendingOrders.length,
      label: 'evento',
      plural: 'eventi',
    },
  ].filter((r) => r.count > 0);

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay bg="rgba(14, 16, 19, 0.7)" backdropFilter="blur(8px)" />
      <ModalContent
        bg="#1e2127"
        borderRadius="20px"
        overflow="hidden"
        maxW="460px"
        mx={4}
        border="1px solid"
        borderColor="rgba(255,255,255,.08)"
        boxShadow="0 24px 60px rgba(0,0,0,.5)"
      >
        <ModalCloseButton
          color="#a3a9b5"
          top={4}
          right={4}
          _hover={{ color: 'white', bg: 'whiteAlpha.100' }}
        />

        <ModalHeader pt={8} pb={2} px={8}>
          <HStack spacing={2} mb={2}>
            <Icon as={FaBell} color="#ffcc00" boxSize={3} />
            <Text
              fontSize="12px"
              fontWeight="700"
              letterSpacing=".14em"
              textTransform="uppercase"
              color="#ffcc00"
            >
              {totalNotifications}{' '}
              {totalNotifications === 1 ? 'notifica' : 'notifiche'}
            </Text>
          </HStack>
          <Text
            fontSize="26px"
            fontWeight="800"
            letterSpacing="-.02em"
            lineHeight="1.1"
            color="#f4f5f7"
          >
            Hai pagamenti in sospeso
          </Text>
        </ModalHeader>

        <ModalBody pt={2} pb={4} px={8}>
          <VStack spacing={3} align="stretch">
            <Text fontSize="15px" color="#a3a9b5" mb={2}>
              Completa i pagamenti per mantenere attivi i tuoi servizi CIL.
            </Text>

            {rows.map((r) => (
              <Flex
                key={r.key}
                align="center"
                gap={4}
                bg="#252930"
                p={4}
                borderRadius="14px"
                border="1px solid"
                borderColor="rgba(255,255,255,.08)"
                borderLeft="3px solid #ffcc00"
              >
                <Icon as={FaExclamationTriangle} color="#ffcc00" boxSize={5} />
                <Box flex="1">
                  <Text fontSize="15px" fontWeight="800" color="#f4f5f7">
                    {r.title}
                  </Text>
                  <Text fontSize="13px" color="#a3a9b5">
                    {r.count} {r.count === 1 ? r.label : r.plural} da pagare
                  </Text>
                </Box>
              </Flex>
            ))}
          </VStack>
        </ModalBody>

        <ModalFooter pt={4} pb={8} px={8} justifyContent="space-between">
          <Button
            variant="unstyled"
            display="inline-flex"
            h="48px"
            fontSize="15px"
            fontWeight="700"
            color="#a3a9b5"
            onClick={handleClose}
            _hover={{ color: 'white' }}
          >
            Chiudi
          </Button>
          <Button
            as={RouterLink}
            to="/account/notifiche"
            bg="#ffcc00"
            color="#16181d"
            h="48px"
            px={6}
            fontSize="15px"
            fontWeight="800"
            borderRadius="8px"
            _hover={{ bg: '#ffd83a', transform: 'translateY(-1px)' }}
            transition="all 0.2s ease"
            onClick={handleClose}
          >
            Gestisci notifiche
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default NotificationPopup;
